module.exports = {"410823001":"木城街道","410823002":"龙源街道","410823003":"龙泉街道","410823004":"木栾街道","410823101":"詹店镇","410823102":"西陶镇","410823103":"谢旗营镇","410823104":"大封镇","410823107":"乔庙镇","410823200":"嘉应观乡","410823202":"圪当店乡","410823203":"三阳乡","410823204":"小董乡","410823205":"大虹桥乡","410823206":"北郭乡","410823598":"武陟宁郭农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410823.json
// module id = 1603
// module chunks = 0